/**
 * Health Hooks
 * React hooks for health checks
 */

import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '../query-keys'
import { healthService } from '../services/health.service'

/**
 * Hook for health check
 */
export function useHealthCheck() {
  return useQuery({
    queryKey: queryKeys.health.check(),
    queryFn: healthService.getHealth,
    retry: 2,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    staleTime: 60000,
  })
}
